<script lang="ts">
    import Svg from "./common/Svg.svelte";
    import {onMount} from "svelte";


    let {search, infourl,  value}: {
        search: (query: string) => void;
        value: string;
        infourl: string;
    } = $props();

    let query = $state(value);

    function doSearch(e: SubmitEvent) {
        e.preventDefault();
        search(query);
    }

    function clearInput() {
        query = "";
        search(query);
    }
</script>

<form class="searchbar"
      onsubmit={doSearch}
>
    <div class="input-container">
        <input type="text" bind:value={query}/>
        <button class="clear"
                aria-label="Clear search query"
                type="button"
                onclick={clearInput}
        >
            <Svg type="times"/>
        </button>
    </div>
    <a href={infourl} target="_blank"
       aria-label="More information"
       class="search-info-link"
    >
        <Svg type="info-circle"/>
    </a>

    <button class="btn-primary search-submit" type="submit">Zoeken</button>
</form>

<style lang="scss">
  .searchbar {
    display: flex;
    gap: 10px;
    border: 1px solid #eee;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;

  }

  .input-container {
    flex: 1;
    position: relative;
    border-radius: 5px;
    border: 3px solid #375698;
    display: flex;

    .clear {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      border: none;
      background: none;
    }

    input {
      flex: 1;
      width: 100%;
      max-width: 100%;
      font-size: 1.9rem;
      color: #375698;
      padding: 5px 20px;
      border: none;
      outline: none;
    }
  }

  .search-info-link {
    display: flex;
    align-items: center;
  }

  .search-submit {
    min-height: 51px;
  }
</style>
